import src from "IMAGE";
export default { src, width: 270, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACA2O/o0PCL9KSgk/SwsLP0tLS39HBwc/RsbG/0QEBD8ADMrOf1HMR7/KSgk/zo6Ov9JSUn/ODg4/z4+Pv8mJib+/H4YUdo4ee8AAAAASUVORK5CYII="};
